import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchPendingProjectRequests } from '@/api/v4/request-project.api';
import { QueryKey } from '@/config/query-client';

interface UsePendingProjectRequestsOptions {
  enabled?: boolean;
}

export const usePendingProjectRequests = (
  options?: UsePendingProjectRequestsOptions,
) => {
  const result = useInfiniteQuery({
    queryKey: [QueryKey.PendingProjectRequests],
    queryFn: ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        items: 20,
      };
      return fetchPendingProjectRequests(params);
    },
    initialPageParam: 1,
    staleTime: 1000 * 10 * 5,
    enabled: options?.enabled ?? true,
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.length ? allPages.length + 1 : undefined;
      return nextPage;
    },
  });

  return {
    ...result,
    data: result.data,
    isLoading: result.isLoading,
    fetchNextPage: result.fetchNextPage,
    hasNextPage: result.hasNextPage,
  };
};
